const surfDestinations = [
  {
    name: 'USA — West Coast',
    description: 'From Malibu to Santa Cruz. Available in 150+ surf shops across California, Hawaii, and Florida.',
    image: 'https://public.readdy.ai/ai/img_res/0be62df7ea49760e1ff38812733031da.jpg',
  },
  {
    name: 'Australia — East Coast',
    description: 'Gold Coast, Byron Bay, Sydney. 185+ stocking retailers. Preferred by Australian surf schools.',
    image: 'https://readdy.ai/api/search-image?query=Australia%20Gold%20Coast%20beach%20surf%20waves%20lifestyle%20photography%20blue%20sky&width=500&height=350&seq=wtb_dest2&orientation=landscape',
  },
  {
    name: 'Europe — Atlantic Coast',
    description: 'Biarritz, Cornwall, Canary Islands, Galicia. 320+ retail locations across 15 European countries.',
    image: 'https://readdy.ai/api/search-image?query=European%20Atlantic%20coast%20surf%20waves%20beach%20lifestyle%20photography%20moody%20dramatic%20light&width=500&height=350&seq=wtb_dest3&orientation=landscape',
  },
  {
    name: 'Asia Pacific',
    description: 'Bali, Mentawai, Philippines, Japan. 210+ locations across the world\'s most surf-dense region.',
    image: 'https://readdy.ai/api/search-image?query=Bali%20tropical%20surf%20beach%20waves%20lifestyle%20photography%20lush%20palm%20trees%20ocean&width=500&height=350&seq=wtb_dest4&orientation=landscape',
  },
];

export default function DistributorSection() {
  return (
    <section className="py-24 bg-[#F5EFE6]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">Global Distribution</p>
          <h2 className="text-4xl md:text-5xl font-black text-stone-900">
            Stocked at the World&apos;s<br />
            <span className="text-[#0B5C4D]">Best Surf Destinations</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-14">
          {surfDestinations.map((d) => (
            <div key={d.name} className="group bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300 cursor-default">
              <div className="h-52 overflow-hidden">
                <img src={d.image} alt={d.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <h3 className="text-stone-900 font-black text-lg mb-2">{d.name}</h3>
                <p className="text-stone-500 text-sm leading-relaxed">{d.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Wholesale enquiry */}
        <div className="bg-[#0B2C26] rounded-3xl p-10 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">For Retailers</p>
            <h3 className="text-3xl font-black text-white mb-4">Become a PHIX Doctor Stockist</h3>
            <p className="text-stone-400 leading-relaxed mb-5">
              Join our global retail network. High-margin, fast-moving products with proven customer demand in every surf market.
            </p>
            <ul className="space-y-2.5 text-stone-300 text-sm">
              {['Competitive wholesale pricing', 'POS display materials included', 'Product training & support', 'Exclusive territory options'].map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <i className="ri-check-line text-[#FF6B35] text-sm" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-[#143D35] rounded-2xl p-7">
            <h4 className="text-white font-black text-lg mb-5">Wholesale Enquiry</h4>
            <form className="space-y-3">
              <input type="text" placeholder="Store / Business Name" className="w-full bg-[#0B2C26] text-white placeholder-stone-500 text-sm px-4 py-3 rounded-xl border border-[#2a6a5a] focus:outline-none focus:border-[#FF6B35]" />
              <input type="email" placeholder="Email Address" className="w-full bg-[#0B2C26] text-white placeholder-stone-500 text-sm px-4 py-3 rounded-xl border border-[#2a6a5a] focus:outline-none focus:border-[#FF6B35]" />
              <input type="text" placeholder="Location / Country" className="w-full bg-[#0B2C26] text-white placeholder-stone-500 text-sm px-4 py-3 rounded-xl border border-[#2a6a5a] focus:outline-none focus:border-[#FF6B35]" />
              <button type="button" className="whitespace-nowrap w-full bg-[#FF6B35] text-white font-bold py-3.5 rounded-xl hover:bg-[#e55a25] transition-colors cursor-pointer">
                Send Enquiry
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
